exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub-headline[data-v-338eb6b0]{font-size:16px}.page-booking-confirmation .page-section[data-v-338eb6b0]{padding:6.25rem 0}.page-booking-confirmation .page-section .grid-cards[data-v-338eb6b0]{margin:2.5rem 0 3rem}.v-overlay[data-v-338eb6b0]{position:fixed}", ""]);

// exports
